<template>
  <div class="projectWrap">
    <!-- header -->
    <Header />

    <!-- project -->
    <div class="project">
      <div class="w1200">
        <!-- tab切换 -->
        <Tabs :animated="false" @on-click="handleTabClick">
          <TabPane v-for="(tab, tabIndex) in caseCenterList" :label="tab.nameCn" :key="tabIndex">
            <div class="project_panel clearfix">

              <!-- 暂无数据 -->
              <p v-if="flag">此分类暂无数据</p>

              <div class="project_box">

                <dl v-for="(item, index) in currentTabList" :key="index">
                  <router-link
                    :to="{ name: 'ProjectDetail', params: { id: item.id } }"
                    target="_blank"
                  >
                    <dd>
                      <img :src="origin + (item.imgUrl.split('|')[0])" :alt="item.nameCn" />
                    </dd>
                    <dt>
                      <span>
                        {{item.address}}
                        <br />{{item.buildYear}}年
                      </span>
                      <i>{{item.area}}m²</i>
                    </dt>
                    <dd>{{item.nameCn}}</dd>
                  </router-link>
                </dl>
              </div>
            </div>
          </TabPane>
        </Tabs>

        <!-- 分页 -->
        <Page :total="totalCount" :page-size="pageSize" @on-change="pagination" />
      </div>
    </div>

    <!-- project_mobile -->
    <div class="project_mobile">
      <dl v-for="(item, index) in allProjectList" :key="index">
        <router-link
          :to="{ name: 'ProjectDetail', params: { id: item.id } }"
          target="_blank"
        >
          <dt>
            <img :src="origin + (item.imgUrl.split('|')[0])" :alt="item.nameCn" />
          </dt>
          <dt>{{item.nameCn}}</dt>
          <dd>
            {{item.address}}<br />
            {{item.buildYear}}年
            <i>{{item.area}}m²</i>
          </dd>
        </router-link>
      </dl>
    </div>

    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import { HomeAllProject, HomeCaseCenter, ProjectTabsOrCustomer } from "@/api/http";
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Vue from 'vue';
import { Tabs, TabPane, Page } from 'iview';
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Page', Page);

export default {
  name: 'project',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      flag: false,
      origin: '', // 域名
      caseCenterList: [], // tabs数据
      allProjectList: [], // 所有项目数据--移动端
      currentTabList: [], // 当前选中tab数据
      tabIndex: 0,  // tabIndex,默认第一个
      totalCount: 0,  // 总条数
      pageNo: 1, // 当前页码
      pageSize: 9, // 每页显示条数
    };
  },
  created() {
    // tabs
    let pathIndex = this.$route.params.index;
    // console.log(pathIndex);
    if(pathIndex == undefined) {
      this.getHomeCaseCenter('pc', 0);
    }else{
      this.getHomeCaseCenter('pc', pathIndex);
    }

    // 所有项目数据
    this.getHomeAllProject();
  },
  methods: {
    // 获取tabs
    getHomeCaseCenter(platform, index) {
      HomeCaseCenter(platform)
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.caseCenterList = res.data.reverse();

        // 获取当前tab数据
        this.getProjectTabs(this.pageNo, this.pageSize, index);
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 所有项目数据
    getHomeAllProject() {
      HomeAllProject()
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.allProjectList = res.data;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 获取当前tab
    handleTabClick(index){
      // console.log(index);
      // 点击当前tab重新获取当前tab的数据
      this.tabIndex = index;
      this.getProjectTabs(this.pageNo, this.pageSize, index);
    },

    // 获取当前tab数据
    getProjectTabs(pageNo, pageSize, index) {
      ProjectTabsOrCustomer({
        "pageNo" : pageNo,
        "pageSize" : pageSize,
        "caseCenterId" : this.caseCenterList[index]['id'],
        "cooperationId" : null
      })
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.currentTabList = res.data.list;
        this.totalCount = res.data.count;
        // 案例分类数据为空时提示
        !this.currentTabList.length ? this.flag = true : this.flag = false;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 分页
    pagination(pageNum) {
      // console.log(pageNum);
      this.getProjectTabs(pageNum, this.pageSize, this.tabIndex);
    },
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/project';
</style>
